export default __webpack_public_path__ + "static/1366x768-909dd4d0fd0d3abdf9285ab43bbe65be.jpg";